import React from 'react'
import { Route } from 'react-router-dom'
import { ROUTE_PATHS } from 'router/routes'
import { QueryParamProvider } from 'use-query-params'

const DigitainSportPage = React.lazy(() => import('pages/DigitainSportPage/DigitainSportPage'))

export class DigitainSportModule {
  getRoutes() {
    return (
      <Route key={ROUTE_PATHS.DIGITAIN_SPORT_PAGE} exact path={ROUTE_PATHS.DIGITAIN_SPORT_PAGE}>
        <QueryParamProvider ReactRouterRoute={Route}>
          <DigitainSportPage />
        </QueryParamProvider>
      </Route>
    )
  }
}
